import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ITaskNavigationFilterArgs } from '../../types/dashboard-types';



@Component({
  standalone: false,
  selector: 'app-dashboard-table',
  templateUrl: './dashboard-table.component.html',
  styleUrls: ['./dashboard-table.component.css']
})
export class DashboardTableComponent {
  @Input() data: any[] = [];
  @Input() columns: any[] = [];
  @Input() title: string = '';

  @Output() onValueClicked : EventEmitter<ITaskNavigationFilterArgs> = new EventEmitter();

  constructor(private router: Router) {}

  getHeaderTemplate(dataField: string): string {
    const statusColumnMap: { [key: string]: string } = {
      'openCount': 'openHeader',
      'pendingCount': 'pendingHeader',
      'holdCount': 'holdHeader',
      'overDueCount': 'overdueHeader',
      'rejectedCount': 'rejectedHeader',
      'cancelledCount': 'cancelledHeader',
      'completedCount': 'completedHeader',
      'totalCount': 'Total'
    };

    return statusColumnMap[dataField] || '';
  }

  onCellClick(e: any) {
    if (e.column && ['openCount', 'pendingCount', 'holdCount', 'overDueCount', 'completedCount', 'rejectedCount', 'cancelledCount'
    , 'totalCount'].includes(e.column.dataField)) {
      const taskIdsKey = e.column.dataField === 'openCount'
        ? 'openTaskIds'
        : e.column.dataField === 'overDueCount'
        ? 'overDueTaskIds'
        : e.column.dataField === 'completedCount'
        ? 'completedTaskIds'
        : e.column.dataField === 'pendingCount'
        ? 'pendingTaskIds'
        : e.column.dataField === 'holdCount'
        ? 'holdTaskIds'
        : e.column.dataField === 'rejectedCount'
        ? 'rejectedTaskIds'
        : e.column.dataField === 'cancelledCount'
        ? 'cancelledTaskIds'
        : e.column.dataField === 'totalCount'
        ? 'all'
        : 'all';

      let taskIds: any[];
      if (taskIdsKey === 'all') {
        // Concatenate all task ID arrays from e.data
        taskIds = [
          ...(e.data.openTaskIds || []),
          ...(e.data.pendingTaskIds || []),
          ...(e.data.holdTaskIds || []),
          ...(e.data.overDueTaskIds || []),
          ...(e.data.completedTaskIds || []),
          ...(e.data.cancelledTaskIds || []),
          ...(e.data.rejectedTaskIds || [])
        ];
      } else {
        taskIds = e.data[taskIdsKey];
      }

      this.onValueClicked.emit({
        taskIds: taskIds
      });
    }
  }

  getCellToolTip(cellData: any): string {
    const taskIdsKey = cellData.column.dataField === 'openCount'
      ? 'openTaskIds'
      : cellData.column.dataField === 'pendingCount'
      ? 'pendingTaskIds'
      : cellData.column.dataField === 'holdCount'
      ? 'holdTaskIds'
      : cellData.column.dataField === 'overDueCount'
      ? 'overDueTaskIds'
      : cellData.column.dataField === 'completedCount'
      ? 'completedTaskIds'
      : cellData.column.dataField === 'rejectedCount'
      ? 'rejectedTaskIds'
      : 'cancelledTaskIds';

    return `Tasks: ${cellData.data[taskIdsKey].join(', ')}`;
  }
}
